import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Default from '../Variants/Default';

const VariantDialogWrapperMap = {
  default: Default,
};

export default class DialogWrapper extends React.Component {
  constructor(props) {
    super(props);
    const { type, cssStyles } = props;
    this.Dialog = VariantDialogWrapperMap[type];
    this.Dialog = withStyles(cssStyles)(this.Dialog);
  }

  render() {
    return (
      <this.Dialog {...this.props} />
    );
  }
}

DialogWrapper.propTypes = {
  type: PropTypes.string,
  cssStyles: PropTypes.object,
};

DialogWrapper.defaultProps = {
  cssStyles: {},
  type: 'default'
};



// WEBPACK FOOTER //
// ./src/widgets/Dialog/DialogWrapper/DialogWrapper.jsx